import styled from '@emotion/styled'
import { Link as GatsbyLink } from '@jelly/ui'

export const Link = styled(GatsbyLink)`
	${({ theme, variant = 'default' }) => theme.links[variant]};
	text-transform: none;
`
